@if (loading()) {
	<lb-loader message="Loading enrollment..."></lb-loader>
} @else if (enrollment()) {
	@if (showTimeline()) {
		<lb-enrollment-timeline
			[enrollment]="enrollment()!"
			[lessons]="lessonState.relatedLessons()"
			[relatedLessonsLoading]="lessonState.relatedLessonsLoading()"
			[activeLessonID]="lessonState.timelineActiveLessonID()"
			[userView]="userView"
			(lessonSelect)="onTimelineLessonSelect($event)"
		></lb-enrollment-timeline>
	}
	<lb-navigation-tab-group class="shell-tabs" [tabList]="tabList()" orientation="horizontal"></lb-navigation-tab-group>
	<div class="shell-content">
		<router-outlet></router-outlet>
	</div>
} @else if (resourceError(); as error) {
	<lb-resource-error [type]="error" resourceLabel="enrollment" backLink="/enrollments" backLabel="All Enrollments"></lb-resource-error>
} @else {
	<lb-loader message="Loading enrollment..."></lb-loader>
}
